<template>
  <Card>
    <p slot="title">发票管理列表</p>
    <template slot="extra">
      <Button type="primary" icon="md-add" @click="exportAction()"
        >发票信息导出</Button
      >
      <Button type="primary" icon="ios-search" @click="handleSearch()"
        >查询</Button
      >
      <Button class="public-fr" type="primary" icon="md-sync" @click="reset()"
        >刷新</Button
      >
    </template>
    <Row>
      <Col span="24">
        <Select
          v-model="params.invoiceType"
          placeholder="请选择发票类型"
          class="public-inp"
        >
          <Option value="1">增值税专用发票</Option>
          <Option value="2">增值税普通发票</Option>
        </Select>
        <Input
          v-model="params.retCode"
          placeholder="请输入门店ID"
          class="public-inp"
        />
        <Input
          v-model="params.retName"
          placeholder="请输入门店名称"
          class="public-inp"
        />
        <Input
          v-model="params.invoiceReceivePhone"
          placeholder="请输入收件人电话"
          class="public-inp"
        />
        <Select
          v-model="params.invoiceIsOpen"
          placeholder="请选择是否开发票"
          class="public-inp"
        >
          <Option value="0">否</Option>
          <Option value="1">是</Option>
        </Select>
        <Input
          v-model="params.grade"
          placeholder="请输入门店等级"
          class="public-inp"
        />
        <Select
          v-model="params.channelCode"
          placeholder="请选择渠道"
          class="public-inp"
        >
          <Option
            v-for="(item, index) in channelList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
        <DatePicker
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择最近修改时间"
          :value="params.invoiceUpdateTime"
          @on-change="timeChange"
        ></DatePicker>
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ index }" slot="sort">
            {{ (params.pageNum - 1) * params.pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="toDetail(row)">查看</a>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="params.pageSize"
          :current="params.pageNum"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>

<script>
const columns = [
  {
    title: "编号",
    slot: "sort",
    fixed: "left",
    width: 66,
  },
  {
    title: "渠道",
    key: "channelCode",
    width: 100,
  },
  {
    title: "资金商",
    key: "dealerName",
    width: 120,
  },
  {
    title: "门店等级",
    key: "grade",
    width: 100,
  },
  {
    title: "零售商名称",
    key: "retName",
    width: 100,
  },
  {
    title: "门店ID",
    key: "retCode",
    width: 100,
  },
  {
    title: "是否开发票",
    key: "invoiceIsOpen",
    width: 80,
    render(h, params) {
      //  0否 1是
      let s = params.row.invoiceIsOpen;
      let t = s == 1 ? "是" : "否";
      return h("span", t);
    },
  },
  {
    title: "开票是否主体本身",
    key: "invoiceIsSelf",
    width: 80,
    render(h, params) {
      //  0否 1是
      let s = params.row.invoiceIsSelf;
      let t = s == 1 ? "是" : "否";
      return h("span", t);
    },
  },
  {
    title: "发票类型",
    key: "invoiceType",
    width: 100,
    render(h, params) {
      // 1-增值税专用发票  2-增值税普通发票)
      let s = params.row.invoiceType;
      let t = s == 1 ? "增值税普通发票" : s == 2 ? "增值税专用发票" : "暂无";
      return h("span", t);
    },
  },
  {
    title: "公司名称",
    key: "invoiceCompany",
    width: 100,
  },
  {
    title: "税号",
    key: "invoiceLecienceCode",
    width: 150,
  },
  {
    title: "单位地址",
    key: "companyAddress",
    width: 150,
  },
  {
    title: "联系电话",
    key: "invoiceMobile",
    width: 150,
  },
  {
    title: "开户银行",
    key: "bankName",
    width: 150,
  },
  {
    title: "银行账户",
    key: "bankAccount",
    width: 150,
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 130,
  },
  {
    title: "审核状态",
    key: "invoiceStatus",
    width: 100,
    render(h, params) {
      // ,0待审核、1审核通过、2审核驳回、/
      let s = params.row.invoiceStatus;
      let t =
        s == 0 ? "待审核" : s == 1 ? "审核通过" : s == 2 ? "审核驳回" : "不开票";
      return h("span", t);
    },
  },
];
export default {
  data() {
    return {
      channelList: [
        { name: "GT", code: "GT" },
        { name: "KA", code: "KA" },
        { name: "OTHERS", code: "OTHERS" },
      ],
      params: {
        channelCode: "",
        dealerName: "",
        grade: "",
        invoiceIsOpen: "",
        invoiceReceivePhone: "",
        invoiceType: "",
        invoiceUpdateTime: "",
        pageNum: 1,
        pageSize: 10,
        retCode: "",
        retName: "",
      },
      total: 0,
      columns,
      tbList: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    toDetail(e) {
      this.$router.push({
        path: "invoiceDetail",
        query: {
          detail: JSON.stringify(e),
        },
      });
    },
    timeChange(v) {
      this.params.invoiceUpdateTime = v;
    },
    getList() {
      this.loading = true;
      let params = this.params;
      this.$api
        .invoiceList(params)
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.tbList = res.data;
            this.total = res.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    // 页码
    pageChange(d) {
      this.params.pageNum = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.params.pageSize = d;
      this.getList();
    },
    // 重置
    reset() {
      for (let key in this.params) {
        this.params[key] = "";
      }
      this.seTime = [];
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    exportAction() {},
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/store/invoiceList.vue